import { companyApis } from '@apis/companyApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { MessageError } from '@utils/errors';

export const useCompanyApplication = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const response = await companyApis.post('/company/application/', {});
      if (response[400]) {
        throw new MessageError(response[400].message);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/company/']);
      },
    },
  );
};
